<template>
  <footer id="footer" class="hidden-print">
    <hr class="funding-hr">
    <div id="funding">
      <p>
        Developed with funding from the U.S. Department of Energy’s Office of Critical Minerals and Energy Innovation.
      </p>
    </div>
    <hr class="funding-hr">
    <div class="footertop">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-5 ps-lg-5">
            <a href="https://www.nlr.gov"
              ><strong>National Laboratory of the Rockies</strong></a
            >
          </div>
          <div class="col col-lg-7">
            <div
              class="d-flex flex-column flex-lg-row justify-content-lg-start global"
            >
              <div>
                <a href="https://www.nlr.gov/about">About</a>
              </div>
              <div>
                <a href="https://www.nlr.gov/research">Research</a>
              </div>
              <div>
                <a href="https://www.nlr.gov/workingwithus">Partner With Us</a>
              </div>
              <div>
                <a href="https://www.nlr.gov/news">News</a>
              </div>
              <div>
                <a href="https://www.nlr.gov/careers">Careers</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footerbottom">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-5 ps-lg-5">
            <div>
              <a href="mailto:FleetREDI@nlr.gov">Contact Us</a>
            </div>
            <div class="mt-2">
              <a href="https://www.nlr.gov/about/visiting-nlr">Visit</a>
            </div>
            <div class="mt-2">
              <a href="https://www.nlr.gov/news/subscribe"
                >Subscribe to NLR</a
              >
            </div>
            <div class="mt-3">
              <ul class="social-links list-inline">
                <li class="list-inline-item">
                  <a
                    href="https://www.facebook.com/nationallaboratoryoftherockies"
                    aria-label="Follow NLR on Facebook"
                    ><font-awesome-icon icon="fa-brands fa-facebook-square" /><!--facebook--></a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://www.instagram.com/natlabrockies/"
                    aria-label="Follow NLR on Instagram"
                    ><font-awesome-icon icon="fa-brands fa-instagram" /><!--Instagram--></a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://www.linkedin.com/company/national-lab-of-the-rockies/"
                    aria-label="Follow NLR on Linked In"
                    ><font-awesome-icon icon="fa-brands fa-linkedin" /><!--Linked In--></a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://www.youtube.com/@nationallaboratoryoftherockies"
                    aria-label="Follow NLR on YouTube"
                    ><font-awesome-icon icon="fa-brands fa-youtube" /><!--You Tube--></a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://x.com/NatLabRockies"
                    aria-label="Follow NLR on X"
                    ><font-awesome-icon icon="fa-brands fa-x-twitter" /><!--X--></a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://www.threads.com/@natlabrockies"
                    aria-label="Follow NLR on Threads"
                    ><font-awesome-icon icon="fa-brands fa-threads" /><!--threads--></a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-8 col-lg-7 globalsecondary">
            <div class="row">
              <div class="col-sm-6 col-lg-3">
                <div class="mt-1 mb-3">
                  <a href="https://www.nlr.gov/accessibility"
                    >Accessibility</a
                  >
                </div>
                <div class="mb-3">
                  <a href="https://www.nlr.gov/disclaimer">Disclaimer</a>
                </div>
                <div class="mb-3">
                  <a href="https://www.nlr.gov/security"
                    >Security and Privacy</a
                  >
                </div>
                <div class="mb-3">
                  <a href="https://www.nlr.gov/webmaster"
                    >Site Feedback</a
                  >
                </div>
              </div>
              <div class="col-sm-6 col-lg-3">
                <div class="mb-3">
                  <a href="https://developer.nlr.gov">Developers</a>
                </div>
                <div class="">
                  <a href="https://thesource.nlr.gov">Employees</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-3">
        <div class="mt-4">
          <div class="row">
            <div class="col-sm-5 ps-lg-4">
              <a href="https://www.alliance-for-energy-innovation.org"
                ><img
                  class="me-3 alliance-logo"
                  src="@/assets/images/alliance-black-logo.svg"
                  alt="Alliance for Energy Innovation, LLC"
              /></a>
              <a href="https://www.energy.gov"
                ><img
                  src="@/assets/images/2025-doe-logo-stacked-horizontal.svg"
                  alt="U.S. Department of Energy"
                  class="doe-logo"
              /></a>
            </div>
            <div class="col-12 col-sm-7 mb-0 d-flex align-items-center mt-3">
              <p class="nrel-attr mb-0">The National Laboratory of the Rockies is a national laboratory of the U.S. Department of Energy, Office of Critical Minerals and Energy Innovation, operated under Contract No. DE-AC36-08GO28308.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
